import { getLocalStorageItem } from './useLocalStorage';
import { AUTH_BEARER_TOKEN_KEY } from 'src/constants';

// This is just a temp utility function to be used in places outside AuthHOC
// AuthHOC redirects if you are not logged in, so use this when we need to check if user is logged in without redirect
// This can be removed once we have a dedicated login ROUTE, not an overlay
const useIsLoggedIn = () => {
  return Boolean(getLocalStorageItem<string>(AUTH_BEARER_TOKEN_KEY));
};

export default useIsLoggedIn;
